/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rust_Faint_Bee_KnitInputs */

const en_rust_faint_bee_knit = /** @type {(inputs: Rust_Faint_Bee_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No rows available in file`)
};

const de_rust_faint_bee_knit = /** @type {(inputs: Rust_Faint_Bee_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Zeilen in der Datei vorhanden`)
};

/**
* | output |
* | --- |
* | "No rows available in file" |
*
* @param {Rust_Faint_Bee_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rust_faint_bee_knit = /** @type {((inputs?: Rust_Faint_Bee_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rust_Faint_Bee_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rust_faint_bee_knit(inputs)
	return de_rust_faint_bee_knit(inputs)
});